import ProviderBadges from './ProviderBadges'

export default ProviderBadges
